// @flow

import type { Action } from '../store.type';

export const UPDATE_FIELD = `SHOPIFY_INTEGRATION_SETTINGS_UPDATE_FIELD`;
type UPDATE_FIELD_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_FIELD';
type UpdateFieldAction = Action<UPDATE_FIELD_TYPE, any>;

export const UPDATE_MULTI_FIELDS = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_MULTI_FIELDS';
type UPDATE_MULTI_FIELDS_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_MULTI_FIELDS';
type UpdateMultiFieldsAction = Action<UPDATE_MULTI_FIELDS_TYPE, any>;

export const CHANGE_ACTIVE_MENU_ITEM = 'SHOPIFY_INTEGRATION_SETTINGS_CHANGE_ACTIVE_MENU_ITEM';
type CHANGE_ACTIVE_MENU_ITEM_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_CHANGE_ACTIVE_MENU_ITEM';
type ChangeActiveMenuItemAction = Action<CHANGE_ACTIVE_MENU_ITEM_TYPE, string>;

export const CHANGE_SELECTED_PAGE = 'SHOPIFY_INTEGRATION_SETTINGS_CHANGE_SELECTED_PAGE';
type CHANGE_SELECTED_PAGE_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_CHANGE_SELECTED_PAGE';
type ChangeSelectedPageAction = Action<CHANGE_SELECTED_PAGE_TYPE, any>;

export const UPDATE_MENU_SETTING = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_MENU_SETTING';
type UPDATE_MENU_SETTING_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_MENU_SETTING';
type UpdateMenuSettingAction = Action<UPDATE_MENU_SETTING_TYPE, any>;

export const UPDATE_WHOLE_MENU_SETTING = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_WHOLE_MENU_SETTING';
type UPDATE_WHOLE_MENU_SETTING_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_WHOLE_MENU_SETTING';
type UpdateWholeMenuSettingAction = Action<UPDATE_WHOLE_MENU_SETTING_TYPE, any>;

export const REMOVE_ELEMENT = 'SHOPIFY_INTEGRATION_SETTINGS_REMOVE_ELEMENT';
type REMOVE_ELEMENT_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_REMOVE_ELEMENT';
type RemoveElementAction = Action<REMOVE_ELEMENT_TYPE, any>;

export const TOGGLE_HIDE_MENU_ITEM = 'SHOPIFY_INTEGRATION_SETTINGS_TOGGLE_HIDE_MENU_ITEM';
type TOGGLE_HIDE_MENU_ITEM_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_TOGGLE_HIDE_MENU_ITEM';
type ToggleHideMenuItemAction = Action<
  TOGGLE_HIDE_MENU_ITEM_TYPE,
  { id: string, updateType: string }
>;

export const UPDATE_THEME_SETTING = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_THEME_SETTING';
type UPDATE_THEME_SETTING_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_UPDATE_THEME_SETTING';
type UpdateThemeSettingAction = Action<UPDATE_THEME_SETTING_TYPE, any>;

// Get theme setting by id
export const GET_THEME_SETTING_BY_ID_REQUEST =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_BY_ID_REQUEST';
type GET_THEME_SETTING_BY_ID_REQUEST_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_BY_ID_REQUEST';

export const GET_THEME_SETTING_BY_ID_SUCCESS =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_BY_ID_SUCCESS';
type GET_THEME_SETTING_BY_ID_SUCCESS_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_BY_ID_SUCCESS';

export const GET_THEME_SETTING_BY_ID_FAILURE =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_BY_ID_FAILURE';
type GET_THEME_SETTING_BY_ID_FAILURE_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_BY_ID_FAILURE';

type GetThemeSettingByIdRequestAction = Action<GET_THEME_SETTING_BY_ID_REQUEST_TYPE, null>;
type GetThemeSettingByIdSuccessAction = Action<GET_THEME_SETTING_BY_ID_SUCCESS_TYPE, any>;
type GetThemeSettingByIdFailureAction = Action<
  GET_THEME_SETTING_BY_ID_FAILURE_TYPE,
  { error: any }
>;

export const TOGGLE_EXPAND_FULLSCREEN = 'SHOPIFY_INTEGRATION_SETTINGS_TOGGLE_EXPAND_FULLSCREEN';
type TOGGLE_EXPAND_FULLSCREEN_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_TOGGLE_EXPAND_FULLSCREEN';
type ToggleFullscreenAction = Action<TOGGLE_EXPAND_FULLSCREEN_TYPE, string>;

// Get theme setting default value by id
export const GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST';
type GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST';

export const GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS';
type GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS';

export const GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE';
type GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE';

type GetThemeSettingDefaultValueByIdRequestAction = Action<
  GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST_TYPE,
  null
>;
type GetThemeSettingDefaultValueByIdSuccessAction = Action<
  GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS_TYPE,
  any
>;
type GetThemeSettingDefaultValueByIdFailureAction = Action<
  GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE_TYPE,
  { error: any }
>;

// Edit theme setting by id
export const EDIT_THEME_SETTING_BY_ID_REQUEST =
  'SHOPIFY_INTEGRATION_SETTINGS_EDIT_THEME_SETTING_BY_ID_REQUEST';
type EDIT_THEME_SETTING_BY_ID_REQUEST_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_EDIT_THEME_SETTING_BY_ID_REQUEST';

export const EDIT_THEME_SETTING_BY_ID_SUCCESS =
  'SHOPIFY_INTEGRATION_SETTINGS_EDIT_THEME_SETTING_BY_ID_SUCCESS';
type EDIT_THEME_SETTING_BY_ID_SUCCESS_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_EDIT_THEME_SETTING_BY_ID_SUCCESS';

export const EDIT_THEME_SETTING_BY_ID_FAILURE =
  'SHOPIFY_INTEGRATION_SETTINGS_EDIT_THEME_SETTING_BY_ID_FAILURE';
type EDIT_THEME_SETTING_BY_ID_FAILURE_TYPE =
  'SHOPIFY_INTEGRATION_SETTINGS_EDIT_THEME_SETTING_BY_ID_FAILURE';

type EditThemeSettingByIdRequestAction = Action<EDIT_THEME_SETTING_BY_ID_REQUEST_TYPE, null>;
type EditThemeSettingByIdSuccessAction = Action<EDIT_THEME_SETTING_BY_ID_SUCCESS_TYPE, any>;
type EditThemeSettingByIdFailureAction = Action<
  EDIT_THEME_SETTING_BY_ID_FAILURE_TYPE,
  { error: any }
>;
export const CHANGE_DEVICE = 'SHOPIFY_INTEGRATION_SETTINGS_CHANGE_DEVICE';
type CHANGE_DEVICE_TYPE = 'SHOPIFY_INTEGRATION_SETTINGS_CHANGE_DEVICE_ACTION_TYPE';
type ChangeDeviceAction = Action<CHANGE_DEVICE_TYPE, number>;

export type ShopifyIntegrationSettingsAction =
  | UpdateMultiFieldsAction
  | UpdateFieldAction
  | ChangeActiveMenuItemAction
  | ChangeSelectedPageAction
  | UpdateMenuSettingAction
  | RemoveElementAction
  | ToggleHideMenuItemAction
  | UpdateWholeMenuSettingAction
  | ToggleFullscreenAction
  | GetThemeSettingByIdRequestAction
  | GetThemeSettingByIdSuccessAction
  | GetThemeSettingByIdFailureAction
  | GetThemeSettingDefaultValueByIdRequestAction
  | GetThemeSettingDefaultValueByIdSuccessAction
  | GetThemeSettingDefaultValueByIdFailureAction
  | UpdateThemeSettingAction
  | EditThemeSettingByIdRequestAction
  | EditThemeSettingByIdSuccessAction
  | EditThemeSettingByIdFailureAction
  | ChangeDeviceAction;

export type ShopifyIntegrationSettingsState = {
  activeMenuItem: string,
  activeMenuItemDetail: any,
  selectedPage: { label: string, value: string },
  collectionSetting: any,
  searchSetting: any,
  commonSetting: any,
  updateType: string,
  device: number,
  listThemeTemplate: any[]
};
